(() => {
  const log  = (...a) => console.log('[GeoSale]', ...a);
  const warn = (...a) => console.warn('[GeoSale]', ...a);
  const err  = (...a) => console.error('[GeoSale]', ...a);

  const cfg = window.geoSaleConfig;
  if (!cfg) {
    err('window.geoSaleConfig not found — is geo-sale.liquid rendered in <head>?');
    return;
  }
  console.clear();
  log('Config loaded:', cfg);

  const handleize = (str) => str.toLowerCase().trim().replace(/\s+/g, '-');

  // Country check
  const qualifyingCountries = cfg.saleCountries
    ? cfg.saleCountries.split(',').map((c) => handleize(c.trim()))
    : [];
  const currentCountry  = handleize(cfg.countryName || '');
  const countryQualifies = currentCountry !== '' && qualifyingCountries.includes(currentCountry);
  log('Country check — detected:', currentCountry, '| passes:', countryQualifies);

  // Date check
  const now      = Date.now();
  const startMs  = cfg.saleStartDate ? new Date(cfg.saleStartDate).getTime() : NaN;
  const endMs    = cfg.saleEndDate   ? new Date(cfg.saleEndDate).getTime()   : NaN;
  const dateQualifies = !isNaN(startMs) && !isNaN(endMs) && now >= startMs && now < endMs;

  const isSaleActive = countryQualifies && dateQualifies;
  log('isSaleActive:', isSaleActive);

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  onReady(() => {
    log('DOM ready — isSaleActive:', isSaleActive);

    if (isSaleActive) {
      applyDiscountCodes();
    }

    logCartDiscountState();    
  });

  // Cart discount state logger
  async function logCartDiscountState() {
    try {
      const cart  = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const codes = (cart.discount_codes ?? []).map((d) => d.code);
      log('Cart discount_codes:', codes.length ? codes : '(none)');
    } catch (e) {
      log('logCartDiscountState: could not fetch /cart.js —', e.message);
    }
  }

  // Helpers
  function getConfiguredCodes() {
    const codes = [];
    if (cfg.discountCodes?.['40']?.trim()) codes.push(cfg.discountCodes['40'].trim());
    if (cfg.discountCodes?.['30']?.trim()) codes.push(cfg.discountCodes['30'].trim());
    return codes;
  }

  // ─── Discount application ─────────────────────────────────────────────────
  async function applyDiscountCodes() {
    const codes = getConfiguredCodes();
    if (codes.length === 0) {
      warn('No discount codes configured. Check discount_code_40 and discount_code_30 in Theme Settings.');
      return;
    }

    const cart         = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    const appliedCodes = (cart.discount_codes ?? []).map((d) => d.code.toUpperCase());
    const pending      = codes.filter((c) => !appliedCodes.includes(c.toUpperCase()));

    if (pending.length === 0) {
      log('Discount codes already applied — skipping:', codes);
      return;
    }

    log('Applying discount codes:', pending);

    for (const code of pending) {
      try {
        const response = await fetch(`/discount/${encodeURIComponent(code)}`, {
          method: 'GET',
          credentials: 'include',
          redirect: 'follow',
        });
        log(`"${code}" — status:`, response.status, '| url:', response.url);
      } catch (e) {
        err(`Failed to apply "${code}":`, e);
      }
    }

    log('All discount codes applied.');

    if (typeof publish === 'function') {
      publish('cart-update', { source: 'geo-sale' });
      log('Cart drawer refresh triggered.');
    }
  }
})();
